// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3riHa","right":"Footer_right__2cauj","buttons":"Footer_buttons__Nf1oD"};